export default function BuyersMarkets() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-14">
          <span className="text-primary-500 text-xs font-body font-medium tracking-widest uppercase">
            Global Markets
          </span>
          <h2 className="font-heading font-semibold text-3xl md:text-4xl text-foreground-950 mt-3 mb-4">
            Trusted Manufacturing Partner
            <br />
            for Global Apparel Brands
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto font-body leading-relaxed">
            Our garments reach consumers in over 20 countries across four continents,
            serving leading international brands and retailers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="bg-background-50 rounded-2xl overflow-hidden">
            <img
              alt="Global export markets map"
              className="w-full object-cover"
              src="https://readdy.ai/api/search-image?query=Minimalist%20world%20map%20with%20highlighted%20trade%20routes%20connecting%20Bangladesh%20to%20Europe%20and%20North%20America%2C%20clean%20corporate%20design%2C%20navy%20blue%20accents%20on%20light%20background%2C%20professional%20infographic%20style&amp;width=800&amp;height=500&amp;seq=world-map&amp;orientation=landscape"
              style={{ aspectRatio: '16 / 10' }}
            />
          </div>

          <div>
            <h3 className="font-heading font-semibold text-xl text-foreground-950 mb-6">
              Export Destinations
            </h3>
            <div className="space-y-5">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                  <h4 className="font-heading font-semibold text-sm text-foreground-950">
                     Export Markets:
                  </h4>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed font-body pl-4">
                 Europe, Asia, the Middle East, North & South America, Australia, and Malaysia
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}